import { render, staticRenderFns } from "./RcHelp.vue?vue&type=template&id=ca354f66"
import script from "./RcHelp.vue?vue&type=script&lang=js"
export * from "./RcHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports